import { frontendURL } from '../../../helper/URLHelper';
import { GROUPS } from './registry';

export const routes = Object.keys(GROUPS).map(group => ({
  path: frontendURL(`accounts/:accountId/data/${group}`),
  name: `mres3_${group}`,
  component: () => import('./Index.vue'),
  props: { group },
  meta: { permissions: ['administrator'] },
}));
